<template>
  <!-- TODO Improves -->
  <div v-if="firstLoad" class="m3 my3">
    <div v-if="!codesListing.value.length" class="p3 white-bg flex my3">
      <span class="flex flex-auto h5n semi-bold justify-center">{{ getReferencelabel("NO_REFERRAL_TEXT") }}</span>
    </div>
    <div v-for="(code, index) in codesListing.value" v-else :key="index" class="py1 white-bg my3">
      <div class="col-12 flex flex-wrap py1">
        <div class="col-12 flex flex-wrap py1">
          <div class="col-12 flex flex-wrap">
            <span class="h4n m0 py2 pl1">{{ getReferencelabel("MY_REFERRAL_TEXT_1") }}</span>
            <span class="h4n bold m0 py2 pl1"> {{ code.firstname }} {{ code.lastname }},</span>
            <span class="h4n m0 py2 pl1">{{ getReferencelabel("MY_REFERRAL_TEXT_2") }} {{ format(new Date(code.expires_at.split('T')[0]), 'dd/MM/yyyy') }}.</span>
            <!-- <p class="h4n bold m0 py2 px2">{{ descriptionReferral(code)}}</p> -->
          </div>
        </div>
        <div class="col-12 flex flex-wrap">
          <span class="h4n m0 pb2 pl1">{{ getReferencelabel("MY_REFERRAL_TEXT_3") }}.</span>
        </div>
      </div>
    </div>
    <div v-if="showMoreButton" class="flex flex-wrap justify-center">
      <Button reference="SEE_MORE" class="col-8 md-col-6 lg-col-4 mb3" btn-color="inverted" :action="loadMoreCodes" />
    </div>
  </div>
</template>

<script>

import { onMounted, ref, reactive, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { format } from 'date-fns';
import Button from '@/components/elements/Button';
import Breadcrumb from '@/components/common/Breadcrumb';
import { getReferencelabel } from '@/mixins/utils';

import { getReferrals } from '@/mixins/requests';

export default {
  components: {
    Breadcrumb,
    Button
  },
  setup () {
    const store = useStore();
    const route = useRoute();
    const firstLoad = ref(false);
    const start = ref(0);
    const limit = ref(3);
    const codesCount = ref(0);
    const codesListing = reactive([]);
    const userUuid = ref(store.state.user.uuid);

    const showMoreButton = computed(() => codesCount.value > (start.value + limit.value));

    // function descriptionReferral(code) {
    //   const expiration = code.expires_at.split('T')[0];
    //   return `${getReferencelabel("MY_REFERRAL_TEXT_1")} ${code.firstname} ${code.lastname} \n ${getReferencelabel("MY_REFERRAL_TEXT_2")} ${format(new Date(expiration), 'dd/MM/yyyy')} ${getReferencelabel("MY_REFERRAL_TEXT_3")} `;
    // }

    function isReferred (code) {
      if (code.referrer_uuid) {
        return code.referrer_uuid == userUuid.value;
      }
      return code == false;
    }

    async function loadMoreCodes () {
      start.value += limit.value;
      await syncCodes();
    }

    async function syncCodes () {
      store.commit('setLoading', true);
      const response = await getReferrals(start.value, limit.value);
      const { count } = response;
      let { items } = response;
      if (items) {
        items = items.filter(r => !r.used);
      }
      codesCount.value = count || 0;
      codesListing.value = [...codesListing.value || [], ...items || []];
      store.commit('setLoading', false);
    }

    onMounted(async () => {
      await syncCodes();
      firstLoad.value = true;
    });

    return { firstLoad, start, limit, codesCount, codesListing, userUuid, showMoreButton, loadMoreCodes, syncCodes, getReferencelabel, route, isReferred, format };
  }
};
</script>

<style>

</style>
